import { useInvalidateCarriersQuery } from "./use-carriers-query";
import { useApiMutation } from "./use-api-mutation";
import type { CreateCarrierDto } from "../generated/schema";

export function useAddCarrier(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/carriers", {
		invalidate: useInvalidateCarriersQuery({ shopId }),
		mapVariables: (data: CreateCarrierDto) => ({
			body: data,
			params: { path: { shopId } },
		}),
	});
}
